<form class="form-vertical" id="editsvform" autocomplete="noway">
  <div class="row">
    <div class="form-group col-md-3">
      <label for="short">Kürzel <span ng-show="vm.sv.old">(ehem. {{vm.sv.old}})</span></label>
      <input type="text" ng-model="vm.sv.short" class="form-control" id="short" tabindex="1"
             placeholder="Kürzel">
    </div>
    <div class="form-group col-md-3">
      <label for="name">Kassencode</label>
      <input type="text" ng-model="vm.sv.code" class="form-control" id="code" tabindex="2"
             placeholder="Kassencode">
    </div>
    <div class="form-group col-md-6">
      <label for="short">Druckerausgabe</label>
      <input type="text" ng-model="vm.sv.printlong" class="form-control" id="printlong" tabindex="1"
             placeholder="Ausgabe Langform">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <label for="name">Name (vollständiger)</label>
      <input type="text" ng-model="vm.sv.name" class="form-control" id="name" tabindex="2"
             placeholder="Vorname">
    </div>
  </div>
  
  <div class="row">
    <div class="form-group col-md-3">
      <label for="phone1">Telefon</label>
      <input type="text" ng-model="vm.sv.phone" class="form-control" id="phone1" tabindex="3"
             placeholder="Telefon">
    </div>
    <div class="form-group col-md-3">
      <label for="fax">Fax</label>
      <input type="text" ng-model="vm.sv.fax" class="form-control" id="fax" tabindex="4"
             placeholder="Fax">
    </div>
    <div class="form-group col-md-6">
      <label for="email">E-Mail</label>
      <input type="text" ng-model="vm.sv.email" class="form-control" id="email" tabindex="5"
             placeholder="E-Mail">
    </div>
  </div>
  
  <div class=" row">
    <div class="form-group col-md-6">
      <label for="address">Adresse</label>
      <input type="text" ng-model="vm.sv.address" class="form-control" id="address" tabindex="6"
             placeholder="Adresse">
    </div>
    <div class="form-group col-md-6">
      <zipcode zip="vm.sv.postcode" city="vm.sv.city" ti="0" ti2="0" parentsave="vm.zipsave(zip, city)"></zipcode>
    </div>
  </div>
  <div class=" row">
    <div class="col-xs-12">
      <div class="form-group">
        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>
        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
      </div>
    </div>
  </div>
</form>